export class UserPasswordCredentials {
  email;
  password;
}
